import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { Typography } from "@mui/material";

interface CustomTooltipProps {
  title: string;
  children: React.ReactElement;
  arrowDirection: "top" | "bottom" | "left" | "right";
}

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }}
  PopperProps={{
    container: typeof window !== 'undefined' && (document.fullscreenElement || document.body),
  }}

  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#192529",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#192529",
    borderRadius: "10px",
    padding: "4px 12px",
    boxShadow: "0px 0px 4px 0px rgba(4, 20, 26, 0.60), 0px 3px 6px 0px rgba(5, 22, 28, 0.60)",
  },
}));

const InfoHoverTooltip: React.FC<CustomTooltipProps> = ({
  title,
  children,
  arrowDirection,
  ...props
}) => {
  return (
    <CustomTooltip
      title={
        <Typography variant="caption" color={"colors.text.primary"}>
          {title}
        </Typography>
      }
      TransitionComponent={Zoom}
      arrow
      placement={arrowDirection}
      {...props}
    >
      {children}
    </CustomTooltip>
  );
};

export default InfoHoverTooltip;
